const refs = {
  searchForm: document.getElementById('search-form'),
};
